export default __webpack_public_path__ + "static/media/bede_white.56fa5c65.svg";